"use client";
import { useEffect, useRef } from "react";
import Image from "next/image";
import AutoScroll from "./AutoScroll";

const clients = [
  "/images/clients/Bosch.png",
  "/images/clients/halonix.png",
  "/images/clients/lucas.jpg",
  "/images/clients/sona_comstar.png",
  "/images/clients/Varroc.jpg",
  "/images/clients/Valeo.png",
];

const ClientsList = () => {
  return (
    <div className="w-full overflow-hidden relative">
      <AutoScroll>
        {[...clients, ...clients].map((logo, index) => (
          <Image
            key={index}
            src={logo}
            alt="Client Logo"
            width={200}
            height={200}
            className="object-contain mx-6"
          />
        ))}
      </AutoScroll>
    </div>
  );
};

export default function Clients() {
  return (
    <div className="relative w-full bg-white py-10 overflow-hidden">
      <div className="text-center mb-6">
        <h2 className="text-3xl font-bold text-gray-800">We Are Authorised Distributor Of</h2>
      </div>
      <ClientsList />
    </div>
  );
}
